<template>
  <div>
    <h6 class="ipo-active-title">{{ $t('ipo.active_order') }}</h6>
    <div class="ipo-status-row">
      <span>{{ $t('ipo.status') }}</span>
      <span>{{ orderStateName(activeOrder.state) }}</span>
    </div>
    <div class="ipo-status-row">
      <span>{{ $t('ipo.quantity') }}</span>
      <span>{{ orderPayload.size }} {{ $t('ipo.qty') }}</span>
    </div>

    <ipo-fee-calculator v-if="feeValue && totalPrice > 0" :fee="feeValue" :total="totalPrice" />

    <div class="ipo-action-row">
      <button
        type="button"
        class="ipo-btn-danger"
        :disabled="cancelling"
        @click="handleCancel"
      >
        <b-spinner v-if="cancelling" small />
        <i v-else class="fas fa-trash"></i>
        {{ $t('ipo.cancel') }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import IpoFeeCalculator from './IpoFeeCalculator.vue'

const ORDER_STATES = {
  1000: 'Хүлээгдэж байна',
  2000: 'Дансны үлдэгдэл хүрэлцэхгүй',
  3000: 'Илгээгдсэн',
  4000: 'Биелсэн',
  5000: 'Цуцлагдсан',
}

export default {
  name: 'IpoActiveOrder',
  components: { IpoFeeCalculator },
  computed: {
    ...mapGetters('ipoOrder', [
      'selectedIpo', 'orderPayload', 'activeOrder', 'cancelling',
    ]),
    totalPrice() {
      const { size } = this.orderPayload
      const price = parseFloat(this.selectedIpo?.detail?.unit_price ?? 0)
      return size > 0 && price > 0 ? parseFloat(size) * price : 0
    },
    feeValue() {
      const stype = this.selectedIpo?.type
      const fees = this.$store.getters['user/user']?.fees || []
      const match = fees.find((f) => f.stype == stype && f.side == 1)
      return match ? parseFloat(match.broker_fee) + parseFloat(match.transaction_fee) : 0
    },
  },
  methods: {
    orderStateName(state) {
      return ORDER_STATES[state] || state
    },
    async handleCancel() {
      const confirmed = await this.$swal({
        title: this.$t('ipo.confirm'),
        text: this.$t('ipo.confirm_cancel_text'),
        showCancelButton: true,
        confirmButtonText: this.$t('ipo.yes'),
        cancelButtonText: this.$t('ipo.no'),
      })
      if (!confirmed.isConfirmed) return
      await this.$store.dispatch('ipoOrder/cancelOrder')
    },
  },
}
</script>
